<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>运单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运单号" prop="freight_bill_code">
                <el-input v-model.trim="searchform.freight_bill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="product_code">
                <el-select
                  v-model="searchform.product_code"
                  placeholder="请输入产品名称模糊匹配或者下拉选择"
                  style="width:100%"
                  :remote-method="getproductlist"
                  filterable
                  remote
                  :loading="productloading"
                  :disabled="show"
                >
                  <el-option
                    v-for="item in productlist"
                    :key="item.product_code"
                    :label="item.product"
                    :value="item.product_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库单号" prop="out_bill_code">
                <el-input v-model.trim="searchform.out_bill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户名称" prop="dealer_name">
                <el-input v-model.trim="searchform.dealer_name" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batch_no">
                <el-input v-model.trim="searchform.batch_no" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库日期" prop="datelist">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.datelist"
                  type="daterange"
                  value-format="timestamp"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="仓库编码" prop="from_warehouse_code">
                <el-input
                  v-model.trim="searchform.from_warehouse_code"
                  style="width:100%"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['freight_select']"
              >搜索</el-button>
              <el-button
                v-permission="['freight_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
              <el-button
                v-permission="['freight_add']"
                type="primary"
                @click="add.addshow=!add.addshow , update.show = false"
              >新增出库单</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <!-- 新增修改模块       -->
      <Freight-Add :add="add" :search="search" />
      <Freight-Update :update="update" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>运单管理</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="freight_bill_code" label="运单号" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="out_bill_code"
              label="出库单号"
              min-width="150"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="batch_no" label="批次号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="out_bill_time"
              label="出库时间"
              min-width="150"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="from_warehouse"
              label="发货仓库"
              min-width="150"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="dealer_name" label="客户" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="客户地址" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品" min-width="250" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column
              prop="package_level_name"
              label="单位"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column> -->
            <el-table-column
              prop="plan_quantity"
              label="计划出库数量"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="confirm_quantity"
              label="出库人工确认数量"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="qty2" label="扫码数量" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="发货状态" min-width="80"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200"></el-table-column>
            <el-table-column label="操作" min-width="260" fixed="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    v-permission="['freight_update']"
                    @click="getoutbilldata(props.row.out_bill_code),update.show =true , add.addshow=false"
                  ></el-button>
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    v-permission="['freight_delete']"
                    @click="deletedate(props.row.out_bill_code)"
                  ></el-button>
                    <el-button
                    type="primary"
                    v-permission="['freight_finish']"
                    @click="updateoutstatus(props.row.out_bill_code)"
                  >出库</el-button>
                  <el-button
                    type="primary"
                    v-permission="['freight_code']"
                    @click="goNav(props.row.freight_bill_code)"
                  >查码</el-button>
                  <!-- <el-button
                    type="primary"
                    v-permission="['orderlist_export']"
                    @click="exportdate(props.row)"
                  >导出</el-button> -->
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  selectoutbillorder,
  donloadoutbillorder,
  deleteoutbillorder,
  updateoutstatus
} from "@/api/physical";
import { downloadoutbill } from "@/api/plant";
import { productlist } from "@/api/base";
import { departtree } from "@/api/orgin";
import { findwarehouse } from "@/api/query";
import FreightAdd from "./components/FreightAdd";
import FreightUpdate from "./components/FreightUpdate";
//引入导出组件模块
export default {
  name: "freight",
  components: { FreightAdd, FreightUpdate },
  mounted() {
    //请求部门列表数据并且便利到表格
    // this.Tabledata();
    this.open();
    this.getdeparttree();
    this.getproductlist();
  },
  data() {
    return {
      //基础数据
      add: {
        addshow: false
      },
      update: {
        form: {
          freightBillCode: null,
          outBillCode: null,
          outBillTime: null,
          fromWarehouseCode: null,
          fromWarehouse: null,
          dealerCode: null
        },
        // 步骤2表格数据
        tablelist: [],
        show: false
      },
      departtree: [],
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据

      searchform: {
        batch_no: null,
        out_bill_code: null,
        dealer_name: null,
        freight_bill_code: null,
        datelist: null,
        sout_bill_date: null,
        eout_bill_date: null,
        from_warehouse_code: null,
        dealer_code: null,
        product_code: null,
        currPage: 1,
        pageSize: 10
      },
      //产品列表下拉
      productloading: false,
      show: false,
      productlist: []
    };
  },
  methods: {
    //跳转到箱码查询
    goNav(freight_bill_code){
       setTimeout(() => {
        //this.$route.query.freight_bill_code = freight_bill_code;
        this.$router.push({
          path: "/boxcode",
          query: { freight_bill_code: freight_bill_code }
        });
      }, 100);
    },
    //完成出库操作
    updateoutstatus(outbillcode) {
      this.$confirm("此操作将该出库单完成出库, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          updateoutstatus({
            outbillcode: outbillcode
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "出库成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "出库失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 下载出库单
    getoutbilldata(outbillcode) {
      document.getElementById("A1").scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth"
      });
      donloadoutbillorder({
        outbillcode: outbillcode
      }).then(response => {
        this.update.form = response.data;
        this.update.form.dealerCode = this.$getTreeDeepArrcode(
          this.update.form.dealerCode,
          this.departtree
        );
        this.update.tablelist = response.data.orderProductsEntityList;
      });
    },
    // //请求部门树结构
    getdeparttree() {
      departtree({ departType: 3 }).then(response => {
        this.departtree = this.getTreeData(response.data);
      });
    },
    getTreeData(data) {
      // 去除树空子集
      for (var i = 0; i < data.length; i++) {
        if (data[i].listSubWareHouses.length < 1) {
          data[i].listSubWareHouses = undefined;
        } else {
          this.getTreeData(data[i].listSubWareHouses);
        }
      }
      return data;
    },
    // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      selectoutbillorder(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼装表格数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].out_bill_time = this.$parseTime(obj[i].out_bill_time); // 出库时间
        obj[i].dealer_name =
          (obj[i].dealer_code || " ") + (obj[i].dealer_name || " ");
        obj[i].from_warehouse =
          (obj[i].from_warehouse_code || " ") + (obj[i].from_warehouse || " ");
        obj[i].product =
          (obj[i].product_code || " ") + (obj[i].product_name || " ");
        switch (obj[i].status) {
          case 0:
            obj[i].status = "未发货";
            break;
          case 1:
            obj[i].status = "已发货";
            break;
          case 2:
            obj[i].status = "已签收";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        batch_no: this.searchform.batch_no,
        out_bill_code: this.searchform.out_bill_code,
        dealer_name: this.searchform.dealer_name,
        freight_bill_code: this.searchform.freight_bill_code,
        sout_bill_date:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        eout_bill_date:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        from_warehouse_code: this.searchform.from_warehouse_code,
        product_code: this.searchform.product_code,
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        batch_no: this.searchform.batch_no,
        out_bill_code: this.searchform.out_bill_code,
        dealer_name: this.searchform.dealer_name,
        freight_bill_code: this.searchform.freight_bill_code,
        sout_bill_date:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        eout_bill_date:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        from_warehouse_code: this.searchform.from_warehouse_code,
        product_code: this.searchform.product_code,
        currPage: this.searchform.currPage,
        pageSize: this.searchform.pageSize
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //删除按钮事件
    deletedate(outbillcode) {
      this.$confirm("此操作将永久删除该出库单信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteoutbillorder({
            outbillcode: outbillcode
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 载入提示
    open() {
      const h = this.$createElement;
      this.search();
      // this.$notify({
      //   title: "页面提示",
      //   message: h("i", "数据量较大，请输入搜索条件进行筛选")
      // });
    },
    //导出表格事件
    handleDownload() {
      if (
        this.searchform.batch_no ||
        this.searchform.out_bill_code ||
        this.searchform.dealer_name ||
        this.searchform.freight_bill_code ||
        this.searchform.from_warehouse_code ||
        this.searchform.product_code ||
        this.searchform.datelist
      ) {
        this.downloadLoading = true;
        const obj = {
          page_index: 1,
          pageSize: this.total_count,
          batch_no: this.searchform.batch_no,
          out_bill_code: this.searchform.out_bill_code,
          dealer_name: this.searchform.dealer_name,
          freight_bill_code: this.searchform.freight_bill_code,
          sout_bill_date:
            this.searchform.datelist == null
              ? null
              : this.searchform.datelist[0],
          eout_bill_date:
            this.searchform.datelist == null
              ? null
              : this.searchform.datelist[1],
          from_warehouse_code: this.searchform.from_warehouse_code,
          dealer_code: this.searchform.dealer_code,
          product_code: this.searchform.product_code
        };
        selectoutbillorder(obj).then(response => {
          this.tableDataDownload = response.data.list;
          this.packdate(this.tableDataDownload);
          import("@/vendor/Export2Excel").then(excel => {
            const tHeader = [
              "运单号",
              "出库单号",
              "批次号",
              "出库时间",
              "发货仓库",
              "客户",
              "客户地址",
              "产品",
              "单位",
              "计划出库数量",
              "箱码数量",
              "扫码数量",
              "发货状态"
            ];
            const filterVal = [
              "freight_bill_code",
              "out_bill_code",
              "batch_no",
              "out_bill_time",
              "from_warehouse",
              "dealer_name",
              "address",
              "product",
              "min_pack_unit",
              "plan_quantity",
              "qty2",
              "countQty",
              "status"
            ];
            const list = this.tableDataDownload;
            const data = this.formatJson(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: this.filename,
              autoWidth: this.autoWidth,
              bookType: this.bookType
            });
            this.downloadLoading = false;
          });
        }); // hear
      } else {
        this.$message({
          type: "warning",
          message: "请输入导出条件"
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    dataURLtoBlob(dataurl) {
      //生产工单导出
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    exportdate(row) {
      console.log(row);
      downloadoutbill({
        outbill_code: row.out_bill_code,
        batch_no: row.batch_no,
        product_code: row.product_code
      })
        .then(response => {
          console.log(response.data);
          const content = this.dataURLtoBlob(response.data);
          const blob = new Blob([content], { type: "application/zip" });
          const fileName = response.message;
          if ("download" in document.createElement("a")) {
            // IE下载
            const elink = document.createElement("a");
            elink.download = "生产工单";
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            // 谷歌火狐下载
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
            if (window.navigator.msSaveBlob) {
              // ie下载
              console.log(window.navigator.msSaveBlob);
              try {
                window.navigator.msSaveBlob(blob, fileName);
              } catch (e) {
                console.log(e);
              }
            }
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>